import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--right",
  "use": "icon-arrow--right-usage",
  "viewBox": "0 0 7 11",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7 11\" id=\"icon-arrow--right\"><path d=\"M1.837 10.27a.615.615 0 0 1-.454.19.65.65 0 0 1-.65-.66c0-.184.077-.352.203-.48l3.822-3.826L.936 1.681A.696.696 0 0 1 .734 1.2c0-.37.29-.66.65-.66.18 0 .333.067.453.19l4.247 4.25a.723.723 0 0 1 .23.52.7.7 0 0 1-.23.514L1.837 10.27Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol